const origin =
  process.env.NODE_ENV !== 'production'
    ? `${window.location.protocol}//${window.location.host.match(/[^:]*/)}:3002`
    : ''

export default origin
